import { useMemo } from "react";
import { i18nParams } from "src/apps/hooks/useGetTranslations";
import { useTranslations } from "src/apps/hooks/useTranslations";
import { Link } from "../link/Link";

type Props = {
  k: string;
  params?: i18nParams;
};

export function unescape(value: string, escapeChars: string[]) {
  return escapeChars.reduce((pre, cur) => pre.replaceAll(`\\${cur}`, cur), value);
}

const escapeChars = ["*"];

const LinkTransformer = ({ value }: { value: string }) => {
  const result = [];
  let currentPosition = 0;
  for (const match of value.matchAll(/\[(?<val>.*?)\]\((?<lnk>.*?)\)/g)) {
    result.push(unescape(value.substring(currentPosition, match.index), escapeChars));
    currentPosition = match.index ?? 0;
    result.push(
      <Link target="_blank" href={match.groups?.lnk ?? ""} key={"link" + match.index}>
        {unescape(match.groups?.val ?? "", escapeChars)}
      </Link>,
    );
    currentPosition += match[0].length;
  }
  result.push(unescape(value.substring(currentPosition), escapeChars));
  return <span>{result}</span>;
};

const StrongTransformer = ({ value }: { value: string }) => {
  const result = [];
  let currentPosition = 0;
  for (const match of value.matchAll(/\*\*(?<val>.*?)\*\*/g)) {
    result.push(
      <LinkTransformer
        value={value.substring(currentPosition, match.index)}
        key={match.index + "link"}
      />,
    );
    currentPosition = match.index ?? 0;
    result.push(
      <strong key={match.index}>
        <LinkTransformer value={match.groups?.val ?? ""} key={match.index} />
      </strong>,
    );
    currentPosition += match[0].length;
  }
  result.push(<LinkTransformer value={value.substring(currentPosition)} key={"end"} />);
  return <span>{result}</span>;
};

export const T = ({ k, params }: Props) => {
  const { translateWithFormat, translations } = useTranslations();

  const components = useMemo(() => {
    const value = translateWithFormat(k, params ?? {}, escapeChars);
    return <StrongTransformer value={value} />;
  }, [k, JSON.stringify(params), translations]);

  return <span>{components}</span>;
};
